import { configureStore } from "@reduxjs/toolkit";
import reducers from "./reducers/index";

/*
Store for redux
*/

const composeEnhancers =  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()

const store = configureStore({ reducer: reducers, composeEnhancers });

export default store;
